import instance from 'utils/apiCalls';
import { APPLICATION_TYPE_URLS } from './applicationTypeUrls';
import { applicationTypeOptionI, paramsI } from '../../../types/interface';
import { applicationTypeSlice } from './applicationTypeSlice';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'redux/store';
import { Action } from '@reduxjs/toolkit';

const { actions } = applicationTypeSlice;

export const createApplicationTypeOption =
  (data: applicationTypeOptionI) => async () => {
    const response = await instance.post(
      `${APPLICATION_TYPE_URLS.APPLICATION_REQ_OPTION}`,
      data
    );
    return response;
  };

export const updateApplicationTypeOption =
  (id: number, data: applicationTypeOptionI) => async () => {
    const response = await instance.put(
      `${APPLICATION_TYPE_URLS.APPLICATION_REQ_OPTION}/${id}`,
      data
    );
    return response;
  };

export const getSingleApplicationTypeOption = (id: number) => async () => {
  const response = await instance.get(
    `${APPLICATION_TYPE_URLS.APPLICATION_REQ_OPTION}/${id}`
  );
  return response;
};

export const getApplicationTypeOptionAll =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(
      APPLICATION_TYPE_URLS.APPLICATION_REQ_OPTION_ALL,
      {
        params: params
      }
    );

    if (response?.data?.meta?.currentPage === 1) {
      dispatch(
        actions.setApplicationTypeTotalPAges({
          totalPages: response?.data?.meta?.totalPages,
          totalRecords: response?.data?.meta?.totalRecords
        })
      );
    }
    return response;
  };

export const getApplicationTypeOptions = () => async () => {
  const response = await instance.get(
    `${APPLICATION_TYPE_URLS.APPLICATION_REQ_OPTION}`
  );
  return response;
};
// application option form droupdown

export const getApplicationTypeOption = () => async () => {
  const response = await instance.get(
    APPLICATION_TYPE_URLS.GET_ALL_PRODUCT_TYPE
  );
  return response;
};

export const deleteApplicationTypeOption = (id: number) => async () => {
  const response = await instance.delete(
    `${APPLICATION_TYPE_URLS.GET_ALL_PRODUCT_OPTION_TYPE}/${id}`
  );
  return response;
};

export const deleteProductMapping =
  (option_id: number, product_id: number) => async () => {
    const response = await instance.delete(
      `${APPLICATION_TYPE_URLS.REMOVE_PRODUCT_MAPPING}/${option_id}/${product_id}`
    );
    return response;
  };
